<template>
  <b-nav-item-dropdown
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu"
      right
  >
    <template #button-content>
      <feather-icon :badge="countQuestion" badge-classes="bg-danger" class="text-body"
                    icon="MailIcon"
                    size="21"
      />
    </template>
    <li class="dropdown-menu-item" v-for="(question,index) in _questions" :key="index">
      <div class="dropdown-header d-flex">
        <a href="https://partner.trendyol.com/questions/products" target="_blank"
           class="notification-title mb-0 mr-auto"> {{ question.name }} </a>
        <b-badge pill variant="light-primary">
          {{ question.count }}
        </b-badge>
      </div>
    </li>

    <li class="dropdown-menu-footer">
      <b-button size="sm" variant="primary" block @click="getControl">Kontrol</b-button>
    </li>

  </b-nav-item-dropdown>
</template>

<script>
import {mapGetters} from "vuex";
import {integer} from "@core/utils/validations/validations";

export default {
  name: "Questions",
  computed: {
    ...mapGetters("question", ["_questions"]),
    countQuestion() {
      let count = 0;
      this._questions.forEach(question => {
        count += parseInt(question.count);
      })
      return count;
    }
  },
  methods: {
    getControl() {
      this.$store.dispatch('question/getControl');
    }
  },
  created() {
    this.$store.dispatch('question/getAll');
    setInterval(() => {
      this.$store.dispatch('question/getAll');
    }, 60000)
  }
}
</script>

<style scoped>

</style>
